import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductProviderModule } from '@epicuro-next/data-providers/product-provider';
import {
  COMMERCIAL_LIST_PROVIDER_TOKEN,
  LIST_ACCESS_PROVIDER_TOKEN,
  LIST_WITH_PRODUCT_SEARCH_PROVIDER_TOKEN,
  OPENED_LIST_DATA_PROVIDER_TOKEN,
  OPENED_LIST_ENTITY_PROVIDER_TOKEN,
} from '@epicuro-next/data-providers/providers-registry';
import { StoreModule } from '@ngrx/store';

import { CommercialListProviderService } from './services/commercial-list-provider.service';
import { ListAccessProviderService } from './services/list-access-provider.service';
import { ListWithProductSearchProviderService } from './services/list-with-product-search.service';
import { OpenedListDataProviderService } from './services/opened-list-data-provider.service';
import { OpenedListEntityProviderService } from './services/opened-list-entity-provider.service';

@NgModule({
  imports: [CommonModule, StoreModule, ProductProviderModule],
  providers: [
    {
      provide: OPENED_LIST_DATA_PROVIDER_TOKEN,
      useClass: OpenedListDataProviderService,
    },
    {
      provide: LIST_ACCESS_PROVIDER_TOKEN,
      useClass: ListAccessProviderService,
    },
    {
      provide: LIST_WITH_PRODUCT_SEARCH_PROVIDER_TOKEN,
      useClass: ListWithProductSearchProviderService,
    },
    {
      provide: OPENED_LIST_ENTITY_PROVIDER_TOKEN,
      useClass: OpenedListEntityProviderService,
    },
    {
      provide: COMMERCIAL_LIST_PROVIDER_TOKEN,
      useClass: CommercialListProviderService,
    },
    ListWithProductSearchProviderService,
  ],
})
export class OpenedListDataProviderModule {}
